// import SlideGameItem from "../slide-game-item";
import {Link, useNavigate} from "react-router-dom";
import React from "react";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import {Swiper, SwiperSlide} from "swiper/react";
// import {Autoplay, Navigation, Pagination,} from "swiper/modules";
import {Navigation} from "swiper/modules";
import 'swiper/css/grid';
import SvgIcon from "../../../components/svg-icon";
import SlideGameItem from "../../../components/slide-game-item";
import {points} from "../../../helpers/splide-helper";
import stringHelper from "../../../helpers/string-helper";


const CasinoGroupSplide = props => {
    const {title, data, icon, path, hideAll = false} = props
    const {configuration} = useSelector(state => state.globalReducer)

    const {i18n, t} = useTranslation();
    const currentLanguage = i18n.language; // Get the current language

    const navigate = useNavigate()
    const handleNavigation = path => navigate(path)

    return (

        <div className="row">
            {
                data?.length >= 1 &&
                <div className="col-12">
                    <div className="section__title-wrap">
                        <h2 className="section__title">
                            <img src={icon} alt="" className={'svg-icon'}/>
                            {title}
                        </h2>
                        {
                            !hideAll &&
                            <Link
                                to={stringHelper.getLocalizedPath(currentLanguage, path)}
                                state={{title: title, image: path}}
                                className="section__view section__view--carousel"
                            >
                                {t('general.view-all')}
                            </Link>
                        }
                    </div>
                </div>
            }

            {
                data?.length >= 1 &&
                <div className="col-12">

                    <Swiper
                        spaceBetween={4} // Space between slides
                        slidesPerView={3.5}
                        breakpoints={points}
                        lazy={"true"}
                        className="mySwiper"
                        loop={true}
                        autoplay={{
                            delay: 5000,
                            disableOnInteraction: false,
                        }}
                        grid={{
                            fill: "row", // Ensures rows are filled row by row
                        }}
                        modules={[Navigation]}
                        navigation
                    >

                        {
                            data?.map((game, i) =>
                                <SwiperSlide key={i}>
                                    <SlideGameItem
                                        game={game}
                                        onClick={handleNavigation}
                                        index={i}
                                        key={i}
                                        passive={game?.blacklist?.includes(configuration.country)}
                                    />
                                </SwiperSlide>
                            )
                        }


                    </Swiper>

                </div>
            }
        </div>

    )


}

export default CasinoGroupSplide
